import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { RenjuBoardCard } from '../../../components'
import { judgePuzzleTurn, createURL } from '../../../lib'
import * as constants from '../../../constants'
import { getWord, WID } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  var marks, insertStrings, stoneType, blackTotal, whiteTotal, card, disabledRemoveMarkButton
  card = state.renjuBoardCards.cards[ownProps.bid]
  var { type, userType, live, editMode, operationMode, isAnalyzeMode, isMarkMode, isPlayMode, isSpecifiedWidth, moves, movesHistory, movesAnalyze, forbiddenPosition, intervalId, scale, analyzeStartNum, cardWidth, settings, gameInfo, puzzleInfo } = card
  var { width } = state.window
  const { language } = state.user

  stoneType = puzzleInfo ? puzzleInfo.stoneType : undefined

  switch (editMode) {
    case constants.editModeType.NORMAL:
      marks = moves[moves.length - 1].marks
      insertStrings = moves[moves.length - 1].insertStrings
      disabledRemoveMarkButton = Boolean(moves[moves.length - 1].marks.length === 0)
      break
    case constants.editModeType.PUZZLE:
      switch (operationMode) {
        case constants.operationModeType.EDIT:
          marks = moves[0].marks
          insertStrings = moves[0].insertStrings
          disabledRemoveMarkButton = Boolean(moves[0].marks.length === 0)
          break
        case constants.operationModeType.SET:
          marks = moves[moves.length - 1].marks
          insertStrings = moves[moves.length - 1].insertStrings
          disabledRemoveMarkButton = Boolean(moves[moves.length - 1].marks.length === 0)
          break
        default:
          break
      }
      blackTotal = moves.filter((move) => move.color === constants.stoneType.BLACK).length
      whiteTotal = moves.filter((move) => move.color === constants.stoneType.WHITE).length
      break
    default:
      break
  }
  
  return ({
    width,
    card,
    type,
    userType,
    liveId: live ? live.liveId : undefined,
    liveStatus: live ? live.status : undefined,
    isAnalyzeMode,
    isMarkMode,
    isPlayMode,
    isSpecifiedWidth,
    editMode,
    operationMode,
    stoneType,
    blackTotal,
    whiteTotal,
    gameInfo,
    puzzleInfo,
    settings,
    intervalId,
    scale,
    moves,
    movesHistory,
    movesAnalyze,
    marks,
    forbiddenPosition,
    insertStrings,
    analyzeStartNum,
    cardWidth,
    disabledRemoveMarkButton,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { bid, disableRightClick, disableLeftClick } = ownProps
  var url, defaultText
  return ({
    resizeBoard: () => dispatch(actions.renjuBoardCard.resizeBoard(bid)),
    handleCloseBoard: () => {
      dispatch(actions.renjuBoardCard.close(bid))
    },
    handleClickRemoveMark: () => {
      dispatch(actions.renjuBoardCard.removeMark(bid))
    },
    handleClickAnalyzeModeOff: () => {
      dispatch(actions.renjuBoardCard.analyzeModeOff(bid))
    },
    handleClickMarkModeOff: () => {
      dispatch(actions.renjuBoardCard.markModeOff(bid))
    },
    handleMarkChange: (event) => {
      dispatch(actions.renjuBoardCard.changedInsertStrings(bid, event.target.value))
    },
    handleClickStoneButton: (stoneType) => () => {
      dispatch(actions.renjuBoardCard.markModeOff(bid))
      dispatch(actions.renjuBoardCard.changedStoneType(bid, stoneType))
    },
    handleClickSwapButton: (swap) => () => {
      dispatch(actions.renjuBoardCard.changedSwap(bid, swap))
    },
    handleClickDecisionButton: (decisionType) => () => {
      dispatch(actions.renjuBoardCard.decision(bid, decisionType))
    },
    handleChangedFiveMoveNumber: (event) => {
      dispatch(actions.renjuBoardCard.changedFiveMoveNumber(bid, event.target.value))
    },
    handleCloseMessage: () => {
      dispatch(actions.renjuBoardCard.closeMessage(bid))
    },
    editModeMenu: {
      handleSelected: (bid, selectedIndex) => {
        dispatch(actions.renjuBoardCard.selectedEditMode(bid, selectedIndex))
      }
    },
    operationModeMenu: {
      handleSelected: (bid, selectedIndex) => {
        dispatch(actions.renjuBoardCard.selectedOperationMode(bid, selectedIndex))
      }
    },
    turnSelectMenu: {
      handleSelected: (bid, selectedIndex) => {
        dispatch(actions.renjuBoardCard.selectedTurnMenu(bid, selectedIndex))
      }
    },
    renjuBoard: {
      handleClick: (event) => {
        if (disableLeftClick !== true) {
          dispatch(actions.renjuBoardCard.clickRenjuBoard(bid, event))
        }
      },
      handleRightClick: (event) => {
        if (disableRightClick !== true) {
          dispatch(actions.renjuBoardCard.rightClickRenjuBoard(bid, event))
        }
        event.preventDefault()
      },
    },
    renjuBoardMenu: {
      handleExited: (clickedMenu) => {
        switch(clickedMenu) {
          case 'AnalyzeModeOn':
            dispatch(actions.renjuBoardCard.analyzeModeOn(bid))
            break
          case 'MarkModeOn':
            dispatch(actions.renjuBoardCard.markModeOn(bid))
            break
          default:
            break
        }
      },
      handleOpenAnalyzeTab: () => {
        dispatch(actions.renjuBoardCard.openAnalyzeTab(bid))
        ownProps.onOpenAnalyzeTab()
      }
    },
    downloadImageDialog: {
      handleEnter: () => {
        dispatch(actions.renjuBoardCard.resizeBoard(bid))
        dispatch(actions.renjuBoardCard.specifiedWidthOn(bid))
      },
      handleExited: () => {
        dispatch(actions.renjuBoardCard.specifiedWidthOff(bid))
      },
    },
    shareDialog: {
      handleEnter: (card, language) => () => {
        url = createURL(card, language)
        dispatch(actions.shareDialog.makedURL(url))
        return 
      },
    },
    tweetDialog: {
      handleEnter: (card, language) => () => {
        dispatch(actions.renjuBoardCard.resizeBoard(bid))
        dispatch(actions.renjuBoardCard.specifiedWidthOn(bid))
        url = createURL(card, language)
        if (card.editMode === constants.editModeType.NORMAL) {
          let { title, blackPlayerName, whitePlayerName } = card.gameInfo
          defaultText = title !== '' ? title + '\n' : ''
          defaultText += blackPlayerName !== '' || whitePlayerName !== '' ? `${blackPlayerName} ${getWord(WID.TWEET_DIALOG.VS, language)} ${whitePlayerName}` : ''
        }
        else if (card.editMode === constants.editModeType.PUZZLE) {
          let turn, turnItem, typeItem, levelStr
          if (card.operationMode === constants.operationModeType.EDIT) {
            if (card.puzzleInfo.selectedTurn === constants.turnType.AUTO) {
              turn = judgePuzzleTurn(card)
            }
            else {
              turn = card.puzzleInfo.selectedTurn
            }
            turnItem = constants.puzzleTurnItems.find((item) => item.value === turn)
          }
          else {
            turnItem = constants.puzzleTurnItems.find((item) => item.value === card.puzzleInfo.turn)
          }
          typeItem = constants.puzzleTypeItems.find((item) => item.value === card.puzzleInfo.type)
          if (card.puzzleInfo.level) {
            levelStr = '★'.repeat(parseInt(card.puzzleInfo.level, 10))
          }
          defaultText = card.puzzleInfo.title ? card.puzzleInfo.title + '\n' : ''
          if (turnItem || typeItem) {
            defaultText += `${turnItem ? getWord(turnItem.wid, language) : ''} ${typeItem ? getWord(typeItem.wid, language) : ''}\n`
          }
          defaultText += levelStr ? `（${getWord(WID.TWEET_DIALOG.LEVEL, language)} : ${levelStr}）\n` : ''
          if (card.puzzleInfo.tags) {
            dispatch(actions.tweetDialog.changedHashTags(card.puzzleInfo.tags))
          }
        }
        dispatch(actions.tweetDialog.makedURL(url))
        dispatch(actions.tweetDialog.defaultText(defaultText))
      },
      handleExited: () => {
        dispatch(actions.renjuBoardCard.specifiedWidthOff(bid))
      }
    },
    gameInfoDialog: {
      handleOK: (gameInfo) => {
        dispatch(actions.renjuBoardCard.changedGameInfo(bid, gameInfo))
      },
    },
    puzzleInfoDialog: {
      handleEnter: (puzzleInfo) => () => {
        dispatch(actions.puzzleInfoDialog.initialize(puzzleInfo))
      },
      handleOK: (puzzleInfo) => {
        dispatch(actions.renjuBoardCard.changedPuzzleInfo(bid, puzzleInfo))
      }
    },
    settingsDialog: {
      handleEnter: (settings) => () => {
        dispatch(actions.settingsDialog.initialize(settings))
      },
      handleOK: (settings) => {
        dispatch(actions.renjuBoardCard.changedSettings(bid, settings))
      }
    },
    fixedButtons: {
      handleOpenMessage: () => {
        dispatch(actions.renjuBoardCard.openMessage(bid))
      }
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RenjuBoardCard)




// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/RenjuBoardCard.js